import React, { useEffect, useState } from 'react';
import { FaShieldAlt } from 'react-icons/fa';

const ActionButton = ({ onClick, children, primary = false }) => {
    const baseClasses = "px-5 py-2.5 rounded-lg text-sm font-semibold transition-all duration-300 ease-in-out transform";
    const primaryClasses = "bg-gradient-to-r from-[#16a085] to-[#13876b] text-white hover:scale-105 shadow-lg hover:shadow-[#16a085]/40";
    const secondaryClasses = "bg-gray-100 text-gray-700 hover:bg-gray-200 hover:scale-105 border border-gray-200";

    return (
        <button
            onClick={onClick}
            className={`${baseClasses} ${primary ? primaryClasses : secondaryClasses}`}
        >
            {children}
        </button>
    );
};

export function CookieBanner({ onAccept, onDecline }) {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setIsVisible(true), 100);
        return () => clearTimeout(timer);
    }, []);

    return (
        // CHANGE 1: Outer container is now positioned to be full-width at the bottom
        <div
            className={`
                fixed bottom-0 inset-x-0 z-[9999] 
                bg-white rounded-t-xl shadow-[0_-8px_20px_rgba(0,0,0,0.1)] border-t border-gray-100
                transition-transform duration-500 ease-out
                ${isVisible ? 'translate-y-0' : 'translate-y-full'}
            `}
        >
            {/* CHANGE 2: Added an inner container to keep content centered on large screens */}
            <div className="max-w-7xl mx-auto px-4 py-3 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-4">
                <div className="flex items-start gap-4">
                    <div className="p-2.5 bg-[#16a085]/10 rounded-full flex-shrink-0">
                        <FaShieldAlt className="h-5 w-5 text-[#16a085]" />
                    </div>
                    <div className="text-gray-700 text-sm">
                        <p className="font-semibold text-gray-900">We value your privacy</p>
                        <p>
                            We use cookies to enhance your browsing experience and analyze our traffic.
                        </p>
                    </div>
                </div>

                <div className="flex gap-3 flex-shrink-0">
                    <ActionButton onClick={onDecline}>
                        Decline
                    </ActionButton>
                    <ActionButton onClick={onAccept} primary>
                        Accept
                    </ActionButton>
                </div>
            </div>
        </div>
    );
}

export default CookieBanner;